<template lang="html">
	<div class="patrimonial-form">
		<template v-if="!isAnonymous">
			<div class="asterisk-container">
				Si vous êtes assujetti à l’IFI (Impôt sur la Fortune Immobilière) et pour gagner du temps, vous pouvez télécharger directement votre dernière déclaration d’IFI
			</div>
			<div class="row start">
				<div class="btn btn-red ctn-icon light" @click="fileInput">
					<span class="icon-button-add"></span>
					Télécharger
					<input id="input-file" type="file" @change="setFile"/>
				</div>
				<div class="filename" v-if="file">
					{{ file.name }}
				</div>
			</div>
		</template>

		<form class="form-ui landscape-patrimonial-ui" novalidate>
			<div class="form-elem-container row">
				<div class="ctn-input ctn-label three">
					<label for="montant">Montant</label>
					<input type="text" name="montant" v-model="amount">
					<custom-select :items="currencies" :selected="currency" @change="currency=$event"/>
				</div>
				<div class="error-message"></div>
			</div>
		</form>
	</div>
</template>

<script>
import CustomSelect from '@/common/components/Form/CustomSelect'
import Currency from '@/common/components/MyPatrimonialLandscape/data/Currency'
import { mapGetters } from 'vuex'

export default {
	name: 'ISF',
	components: {
		CustomSelect
	},
	data () {
		return {
			amount: null,
			currency: 'EUR',
			currencies: Currency,
			file: null
		}
	},
	mounted () {
		this.amount = this.estate.isf.amount || null
		this.currency = this.estate.isf.cur || 'EUR'
	},
	methods: {
		validate () {
			return this.$validator.validate()
		},
		save () {
			if (this.file) this.$emit('fileupload', this.file)
			return new Promise((resolve, reject) => {
				this.validate().then((validation) => {
					if (validation) {
						this.$store.dispatch('storePatrimonial', {
							name: 'ISF',
							data: {
								amount: this.amount,
								cur: this.currency
							},
							fromStart: false
						}).then(() => {
							resolve()
						})
					}
				})
			})
		},
		fileInput () {
			document.getElementById('input-file').click()
		},
		setFile (e) {
			console.log(e)
			this.file = e.target.files[0]
		}
	},
	beforeDestroy () {
		this.save()
	},
	computed: {
		...mapGetters({
			estate: 'estate',
			isAnonymous: 'isAnonymous'
		})
	}
}
</script>

<style lang="scss" scoped>
	.btn {
		margin-bottom: 1rem;
	}

	#input-file {
		display: none;
	}

	.start {
		justify-content: flex-start;
		align-items: baseline;

		.filename {
			margin-left: 0.5rem;
			font-size: 0.8rem;
		}
	}
</style>



// WEBPACK FOOTER //
// src/common/components/MyPatrimonialLandscape/ISF.vue